import { render, staticRenderFns } from "./pkqUserStatistics.vue?vue&type=template&id=be1b30c8&scoped=true"
import script from "./pkqUserStatistics.vue?vue&type=script&lang=js"
export * from "./pkqUserStatistics.vue?vue&type=script&lang=js"
import style0 from "./pkqUserStatistics.vue?vue&type=style&index=0&id=be1b30c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1b30c8",
  null
  
)

export default component.exports